import { add, addSeconds, intervalToDuration, isWithinInterval, milliseconds } from "date-fns";

type Nullable<T> = { [K in keyof T]: T[K] | null };

export type NullableDuration = Nullable<Duration>;

export interface TimeConfig {
  min?: Duration;
  max?: Duration;
}

export const isTimeInvalid = (time: number | undefined, config: TimeConfig) => {
  if (time === undefined) {
    return;
  }

  const { min, max } = config;

  const now = new Date();
  const selectedTime = addSeconds(now, time);

  return !isWithinInterval(selectedTime, {
    start: min ? add(now, min) : now,
    end: max ? add(now, max) : now
  });
};

export const removeNullsFromDuration = (time: NullableDuration): Duration => {
  const nonNullableTime: Duration = {};
  Object.entries(time).forEach(([key, val]) => {
    if (val === null) {
      return;
    }
    nonNullableTime[key as keyof NullableDuration] = val;
  });
  return nonNullableTime;
};

export const durationToSeconds = (duration: NullableDuration | Duration | undefined) =>
  duration !== undefined ? milliseconds(removeNullsFromDuration(duration)) / 1000 : undefined;
export const secondsToDuration = (seconds: number | undefined) =>
  seconds !== undefined ? intervalToDuration({ start: 0, end: seconds * 1000 }) : undefined;
